import { SvgIcon, SvgIconProps } from '@mui/material'

const GuardColoredIcon = ({ fill = '#122937', ...props }: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="18"
        height="17"
        viewBox="0 0 18 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.52355 2.66127C7.72244 2.08269 8.26676 1.69421 8.87858 1.69421C9.4904 1.69421 10.0347 2.08269 10.2336 2.66127L15.1145 16.8603H2.64264L7.52355 2.66127Z"
          fill={fill}
        />
        <path
          opacity="0.5"
          d="M11.8015 2.91208L16.5449 1.14223C16.9222 1.00148 17.324 1.28043 17.324 1.68307V5.52627C17.324 5.92761 16.9245 6.20647 16.5478 6.06816L11.8044 4.32686C11.5771 4.24343 11.4261 4.02706 11.4261 3.78496V3.45292C11.4261 3.21194 11.5757 2.99632 11.8015 2.91208Z"
          fill={fill}
        />
        <rect
          x="0.591492"
          y="16.0012"
          width="16.0088"
          height="0.859088"
          rx="0.429544"
          fill="#88949B"
        />
        <rect
          x="4.39124"
          y="6.74863"
          width="8.97522"
          height="0.859088"
          rx="0.429544"
          fill="#88949B"
        />
      </svg>
    </SvgIcon>
  )
}

export default GuardColoredIcon
